import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClerkProvider } from "@clerk/react";
import { hiIN } from "@clerk/localizations";
import { useT } from "../../lib/i18n";

const appearance = {
  variables: { colorPrimary: "#B45309", colorForeground: "#111827", borderRadius: "0.625rem", fontFamily: "DM Sans, sans-serif" },
};

const HI_LOCALIZATION = {
  ...hiIN,
  formFieldInputPlaceholder__signUpPassword: "एक पासवर्ड बनाएँ",
  unstable__errors: { ...hiIN.unstable__errors, ticket_invalid_code: "यह लिंक अब मान्य नहीं है या पहले ही उपयोग हो चुका है। कृपया फिर से शुरू करें या नया लिंक माँगें।" },
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ClerkAuthProvider({ children }) {
  const navigate = useNavigate();
  const [config, setConfig] = useState(null);
  const [unavailable, setUnavailable] = useState(false);
  const { lang, tl } = useT();

  useEffect(() => {
    let cancelled = false;
    const load = async (attempt = 0) => {
      try {
        const cfg = await (await fetch(`${BACKEND_URL}/api/clerk/config`)).json();
        if (cfg.enabled) return cancelled || setConfig(cfg);
      } catch {}
      if (cancelled) return;
      if (attempt >= 20) return setUnavailable(true);
      setTimeout(() => load(attempt + 1), 1500);
    };
    load();
    return () => { cancelled = true; };
  }, []);

  if (unavailable) return <p style={{ padding: 24 }} data-testid="signin-unavailable">{tl("Sign-in is unavailable right now. Refresh the page to try again.")}</p>;
  if (!config) return null;
  return (
    <ClerkProvider
      publishableKey={config.publishable_key}
      proxyUrl={config.proxy_url || undefined}
      appearance={appearance}
      localization={lang === "hi" ? HI_LOCALIZATION : undefined}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      signInFallbackRedirectUrl="/dashboard"
      signUpFallbackRedirectUrl="/dashboard"
      afterSignOutUrl="/"
    >
      {children}
    </ClerkProvider>
  );
}
